import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const API_BASE = '/api';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      await fetch(`${API_BASE}/auth/request-password-reset`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
    } finally {
      // always show the same confirmation, regardless of the actual result —
      // matches the backend's non-enumeration behavior
      setSubmitted(true);
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-image">
          <img
            src="/Galldris-Logo-White-Yellow.png"
            alt="Galldris Group"
            className="login-image-logo"
          />
        </div>

        <div className="login-form-side">
          {submitted ? (
            <>
              <h1 className="login-heading">Check Your Email</h1>
              <p>If an account exists with that email, a password reset link has been sent. The link expires in 1 hour.</p>
              <Link to="/admin" className="btn-secondary btn-full-width btn-back-to-login">
                Back to Login
              </Link>
            </>
          ) : (
            <>
              <h1 className="login-heading">Reset Your Password</h1>
              <p>Enter your email and we'll send you a link to reset your password.</p>

              <form onSubmit={handleSubmit}>
                <div className="form-field">
                  <label>Email</label>
                  <input
                    type="email"
                    className="login-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <button type="submit" className="btn-primary btn-full-width" disabled={submitting}>
                  {submitting ? 'Sending...' : 'Send Reset Link'}
                </button>

                <Link to="/admin" className="forgot-password-link btn-back-link-inline">
                  Back to Login
                </Link>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;